import { render, staticRenderFns } from "./EntityDiagram.vue?vue&type=template&id=60a23c08"
import script from "./EntityDiagram.vue?vue&type=script&lang=js"
export * from "./EntityDiagram.vue?vue&type=script&lang=js"
import style0 from "./EntityDiagram.vue?vue&type=style&index=0&id=60a23c08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports